<template lang="pug">
component.link(
  v-bind="props"
  :is="isType"
  :aria-label="props.ariaLabel || props.text || ''"
  :class="allClasses"
)
  template(v-if="$slots.prevLabel" #prevLabel)
    slot(name="prevLabel" :text="props.text")
  template(v-if="$slots.icon" #icon)
    slot(name="icon")
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { type DestinationItemArchetypeProps } from './DestinationItemArchetype.types';
import { destinationItemArchetypeDefaults } from './DestinationItemArchetype.defaults';
import useSkin from '../../../composables/useSkin';
import useSkinDestination from '../../../composables/useSkinDestination';
import usePrimitiveResolver from '../../../composables/usePrimitiveResolver';

const props = withDefaults(
  defineProps<DestinationItemArchetypeProps>(),
  destinationItemArchetypeDefaults as any,
) as unknown as DestinationItemArchetypeProps;

const { allClasses: baseClasses } = useSkin(props as any);
const { allClasses: destClasses } = useSkinDestination(props as any);

const allClasses = computed(() => {
  return [baseClasses.value, destClasses.value].filter(Boolean).join(' ');
});

const { isType } = usePrimitiveResolver(props as any);
</script>

<style>
.link {
  display: flex;
}
</style>
